import React from 'react';
import { Instagram } from 'lucide-react';

const instagramImages = [
  'https://clinicaeranza.com/wp-content/uploads/2024/03/20230715-144428-1.jpg',
  'https://clinicaeranza.com/wp-content/uploads/2024/03/20230715-143941.jpg',
  'https://clinicaeranza.com/wp-content/uploads/2024/03/20230715-142917.jpg',
  'https://images.pexels.com/photos/3985316/pexels-photo-3985316.jpeg?w=400&q=80',
  'https://images.unsplash.com/photo-1731514721772-329626f84c8b?w=400&q=80',
  'https://images.unsplash.com/photo-1620331311520-246422fd82f9?w=400&q=80'
];

const InstagramGallery = () => {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-muted/30">
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-4">
            <Instagram className="w-8 h-8 text-primary" />
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground">
              Síguenos en <span className="text-gradient-primary">Instagram</span>
            </h2>
          </div>
          <a
            href="https://www.instagram.com/estetica.eranza"
            target="_blank"
            rel="noopener noreferrer"
            className="text-lg text-muted-foreground hover:text-primary transition-colors"
          >
            @estetica.eranza
          </a>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {instagramImages.map((image, index) => (
            <a
              key={index}
              href="https://www.instagram.com/estetica.eranza"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square overflow-hidden rounded-lg"
            >
              <img
                src={image}
                alt={`Instagram post ${index + 1}`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/20 transition-colors duration-300 flex items-center justify-center">
                <Instagram className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-8">
          <a
            href="https://www.instagram.com/estetica.eranza"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-primary text-primary-foreground font-medium rounded-full hover:shadow-glow transition-all duration-300"
          >
            <Instagram className="w-5 h-5" />
            Visita nuestro Instagram
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramGallery;
